import type { PresignResponse } from "@spare-cart/contracts/media";
import { apiClient } from "@core/api";

const toFormData = (fields: Record<string, string> | undefined, file: File): FormData => {
  const form = new FormData();
  for (const [key, value] of Object.entries(fields ?? {})) form.append(key, value);
  form.append("file", file, file.name);
  return form;
};

export const uploadSearchImage = async (file: File): Promise<string> => {
  const presign = await apiClient.post<PresignResponse>("/media/presign/search-image", {
    fileName: file.name,
    contentType: file.type,
    sizeBytes: file.size,
  });

  const upload =
    presign.method === "POST"
      ? await fetch(presign.uploadUrl, { method: "POST", body: toFormData(presign.fields, file) })
      : await fetch(presign.uploadUrl, { method: "PUT", headers: presign.headers, body: file });
  if (!upload.ok) throw new Error(`Upload failed with status ${upload.status}`);

  return presign.publicUrl;
};
